<template>
    <div class="service-listing">
        <div class="container">
            <div class="row">
                <div class="col-12 responsive-cancel-padding tablet-full-width">
                    {{ sliderKeyword }}
                    <serviceslider :allCat="sliderArr"
                                   :filerSlider="filterData"
                                   :key="reinitSlider"
                                   :tarckApplyFilter="tarckApplyFilter"
                                   @sliderKeyword="(sliderCat = $event), (slideClicked = true)"
                                   v-if="sliderArr.length > 1" />
                </div>
                <div class="col-xs-3 col-lg-3 responsive-cancel-padding cancel-left-padding tablet-full-width">
                    <div class="filter-component">
                        <filterservice :apiResponse="info"
                                       :filter="filterData"
                                       @depArr="depArr = $event"
                                       @categoryArr="cateArr = $event"
                                       @sectorArr="sectorArr = $event"
                                       @subArr="subArr = $event"
                                       @healthArr="healthArr = $event"
                                       @funcArr="funcArr = $event"
                                       @tarckApplyFilter="tarckApplyFilter = true"
                                       :filterClicked="tarckApplyFilter"
                                       v-if="info"
                                       :sectorLab="SectorLabel"
                                       :categoryLab="CategoryLabel"
                                       :productLab="ProductsLabel"
                                       :functionsLab="FunctionsLabel"
                                       :searchLab="SearchLabel"
                                       :checkCat="checkCateg"
                                       :checkSector="checkSector"
                                       :BackBtn="BackBtn"
                                       :Apply="Apply"
                                       :Reset="Reset"
                                       :key="reinitFilter" />
                        <div class="generic-loader filter-loader" v-if="apiCallLoader">
                            <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
                        </div>
                    </div>
                </div>
                <div class="col-xs-9 col-lg-9 responsive-cancel-padding tablet-full-width">
                    <div class="accordion-wrapper">
                        <servicesearch @searchKeyword="searchWord = $event"
                                       :searchFilter="filterData"
                                       :searchLab="SearchLabel"
                                       :searchPlaceHolder="SearchPlaceHolder" />
                        <div class="generic-loader" v-show="isAjaxLoading">
                            <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
                        </div>

                        <h3 v-if="noDataMsg" class="empty-msg">
                            {{ NoResultMessage }}
                        </h3>

                        <div class="accordion" id="accordionExample">
                            <div class="card"
                                 v-for="(item, index) in filteredData"
                                 :key="index">
                                <a :href="item.Url" class="details-arrow">
                                    <img src="../../../Assets/Images/left-white-arrow.png"
                                         alt="arrow" />
                                </a>
                                <a class="card-body card-title">
                                    {{ item.ServiceName }}
                                </a>

                                <div :id="'A' + item.Id"
                                     class="collapse"
                                     :class="
                    index == 0 || (index == 0 && mobileView) ? 'show' : ''
                  "
                                     aria-labelledby="headingOne"
                                     data-parent="#accordionExample">
                                    <div class="card-body">
                                        <div class="seprator"
                                             style="
                        background-image: url('../../../Assets/Images/seprator.svg');
                      "></div>

                                        <div class="row data">
                                            <div class="col-sm-12 col-lg-6">
                                                <div class="data__details">
                                                    <div class="data__details__title">
                                                        {{ ServiceCost }}
                                                    </div>
                                                    <div class="data__details__description">
                                                        {{
                              item.ServiceFees != "" ? item.ServiceFees : "-"
                                                        }}
                                                    </div>
                                                </div>
                                                <div class="data__details">
                                                    <div class="data__details__title">
                                                        {{ CentralAdministration }}
                                                    </div>
                                                    <div class="data__details__description">
                                                        <div>
                                                            {{ item.Sector != null ? item.Sector : "-" }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="data__details">
                                                    <div class="data__details__title">
                                                        {{ PublicAdministration }}
                                                    </div>
                                                    <div class="data__details__description">
                                                        {{
                              item.Department != null ? item.Department : "-"
                                                        }}
                                                    </div>
                                                </div>
                                                <div class="data__details">
                                                    <div class="data__details__title">
                                                        {{ Specialization }}
                                                    </div>
                                                    <div v-if="item.Functions != null"
                                                         class="data__details__description">
                                                        <span v-for="(func, index) in item.Functions"
                                                              :key="index">
                                                            {{ func }}
                                                        </span>
                                                    </div>
                                                    <div v-else class="data__details__description">
                                                        <span>-</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-lg-6">
                                                <div class="data__details">
                                                    <div class="data__details__title">
                                                        {{ Cosmetic }}
                                                    </div>
                                                    <div>
                                                        <div v-if="item.HealthProducts != null"
                                                             class="data__details__description">
                                                            <span v-for="(health, index) in item.HealthProducts"
                                                                  :key="index">
                                                                {{ health }}
                                                            </span>
                                                        </div>
                                                        <div v-else class="data__details__description">
                                                            <span>-</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="data__details">
                                                    <div class="data__details__title">
                                                        {{ SecondaryCategory }}
                                                    </div>
                                                    <div class="data__details__description">
                                                        {{
                              item.SubCategory != null ? item.SubCategory : "-"
                                                        }}
                                                    </div>
                                                </div>

                                                <div class="data__details">
                                                    <div class="data__details__title">
                                                        {{ Category }}
                                                    </div>
                                                    <div class="data__details__description">
                                                        {{ item.Category != null ? item.Category : "-" }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-header" id="headingOne">
                                    <h2 class="mb-0">
                                        <button class="btn btn-link btn-block text-center filterCollapse"
                                                :class="
                        index == 0 || (index == 0 && mobileView)
                          ? ''
                          : 'collapsed'
                      "
                                                type="button"
                                                data-toggle="collapse"
                                                :data-target="'#A' + item.Id"
                                                aria-expanded="true"
                                                :aria-controls="'A' + item.Id">
                                            <!-- <i class="icon-expand"></i> -->
                                            <div class="icon-wrapper">
                                                <div class="custom-icon-expand">
                                                    <div class="custom-icon-expand__rect"></div>
                                                    <div class="custom-icon-expand__triangle"></div>
                                                </div>

                                                <div class="custom-icon-collapse">
                                                    <div class="custom-icon-collapse__triangle"></div>
                                                    <div class="custom-icon-collapse__rect"></div>
                                                </div>
                                            </div>
                                        </button>
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import filterservice from "../Filter/FilterService.vue";
    import serviceslider from "../ServiceSlider/ServiceSlider.vue";
    import servicesearch from "../ServiceSearch/ServiceSearch.vue";
    import axios from "axios";
    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";
    let language = window.CurrentLanguage.CurrentLanguage;

    export default {
        props: [
            "checkSector",
            "SectorLabel",
            "CategoryLabel",
            "ProductsLabel",
            "FunctionsLabel",
            "SearchLabel",
            "SearchPlaceHolder",
            "checkCateg",
            "NoResultMessage",
            "BackBtn",
            "Apply",
            "Reset",
            "PageType",
            "AllCateg",
            "ServiceCost",
            "CentralAdministration",
            "PublicAdministration",
            "Specialization",
            "Cosmetic",
            "SecondaryCategory",
            "Category",
        ],
        components: {
            filterservice,
            serviceslider,
            servicesearch,
        },
        data() {
            return {
                pageNumber: 1,
                searchWord: "",
                sliderKeyword: "",
                slideClicked: false,
                returnedNameFilter: null,
                info: null,
                allCategories: [
                    {
                        CategoryName: this.AllCateg,
                        Icon: "/Assets/Images/all.png",
                        SubCategories: [],
                    },
                ],
                userIds: [],
                data: [],
                sliderCat: [],
                cateArr: [],
                sectorArr: [],
                subArr: [],
                healthArr: [],
                funcArr: [],
                depArr: [],
                mobileView: false,
                tarckApplyFilter: false,
                isAjaxLoading: true,
                filteredData: [],
                noDataMsg: false,
                limit: 10,
                reinitFilter: 1,
                reinitSlider: 1,
                pageLoad: true,
                apiCallLoader: false,
                sliderArr: [
                    {
                        CategoryName: this.AllCateg,
                        Icon: "/Assets/Images/all.png",
                        SubCategories: [],
                    },
                ],
            };
        },
        methods: {
            async getInfo() {
                await axios
                    .post(
                        `${apiUrl}/Umbraco/Surface/Generic/GetAllFilters?pageType=${this.PageType}&culture=${language}`
                    )
                    .then((response) => {
                        this.info = response.data;
                        if (this.pageLoad) {
                            this.info.Categories.map((x) => this.allCategories.push(x));
                            this.info.Categories.map((x) => this.sliderArr.push(x));
                            this.info.Categories = this.allCategories;
                        }
                        if (this.slideClicked) {
                            this.info.Categories.map((x) => this.allCategories.push(x));
                            this.info.Categories = this.allCategories;
                        }
                        if (this.tarckApplyFilter) {
                            this.info.Categories.map((x) => this.sliderArr.push(x));
                            //this.info.Categories = this.sliderArr;
                        }
                        //this.info.Categories = allCat;

                        // let UserObj = {};

                        for (let item of this.info.Categories || []) {
                            this.$set(item, "checked", false);
                            item.SubCategories = item.SubCategories.map((str, index) => ({
                                value: str,
                                id: index + 1,
                                checked: false,
                            }));
                        }

                        for (let item of this.info.Sectors || []) {
                            this.$set(item, "checked", false);
                            item.Department = item.Department.map((str, index) => ({
                                value: str,
                                id: index + 1,
                                checked: false,
                            }));
                        }

                        for (let item of this.info.HealthProducts || []) {
                            this.$set(item, "checked", false);
                        }

                        for (let item of this.info.Functions || []) {
                            this.$set(item, "checked", false);
                        }

                        this.pageLoad = false;
                        this.slideClicked = false;
                        this.tarckApplyFilter = false;
                    });
            },
            filterData() {
                this.isAjaxLoading = true;
                this.noDataMsg = false;
                this.data = [];
                if (this.searchWord || this.slideClicked || this.tarckApplyFilter) {
                    this.pageNumber = 1;
                    this.filteredData = [];
                }

                if (this.tarckApplyFilter) {
                    if (window.innerWidth > 1025) {
                        this.apiCallLoader = true;
                    }
                    this.reinitSlide++;
                }
                if (this.slideClicked) {
                    this.cateArr = this.sliderCat;
                    this.healthArr = [];
                    this.funcArr = [];
                    this.subArr = [];
                    this.depArr = [];
                    this.sectorArr = [];
                    this.allCategories = [this.allCategories[0]];
                    this.reinitFilter++;
                    this.getInfo();
                }

                setTimeout(() => {
                    let axiosData = {
                        PageType: this.PageType,
                        Text: this.searchWord,
                        PageNumber: this.pageNumber,
                        Categories: this.cateArr,
                        HealthProducts: this.healthArr,
                        Functions: this.funcArr,
                        SubCategories: this.subArr,
                        Departments: this.depArr,
                        Sectors: this.sectorArr,
                    };

                    axios
                        .post(
                            `${apiUrl}/Umbraco/Surface/Generic/ApplyFilters?culture=${language}`,
                            axiosData
                        )
                        .then((response) => {
                            this.apiCallLoader = false;
                            let apiData = JSON.parse(JSON.stringify(response.data));
                            apiData.map((x) => {
                                if (location.pathname.includes("/ar")) {
                                    x.ServiceFees = x.ServiceFees.replace(/[0-9]/gim, (number) =>
                                        parseInt(number).toLocaleString("ar-EG")
                                    );
                                }
                            });
                            this.data = response.data;
                            if (this.data.length != 0) {
                                if (this.pageNumber == 1) {
                                    this.filteredData = apiData;
                                } else {
                                    this.slice(apiData);
                                }
                            }
                            this.isAjaxLoading = false;
                            this.slideClicked = false;
                            this.tarckApplyFilter = false;
                            if (this.filteredData.length == 0) {
                                this.noDataMsg = true;
                            } else {
                                this.noDataMsg = false;
                            }
                        })
                        .catch(() => { });
                }, 100);
            },
            slice(data) {
                // const append = this.data.slice(
                //   this.filteredData.length,
                //   this.filteredData.length + this.limit
                // );

                this.filteredData = this.filteredData.concat(data);
            },
            checkTrigger() {
                const options = {
                    threshold: 0.1,
                };
                const checker = document.querySelector(".footer");
                const infiniteScroll = (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            if (this.data.length != 0) {
                                this.isAjaxLoading = true;
                                setTimeout(() => {
                                    if (window.innerWidth > 1025) {
                                        this.apiCallLoader = true;
                                    }
                                    this.pageNumber++;
                                    this.filterData();
                                    this.isAjaxLoading = false;
                                }, 500);
                            }
                        }
                    });
                };

                const observer = new IntersectionObserver(infiniteScroll, options);
                observer.observe(checker);
            },
        },
        mounted() {
            this.getInfo();
            this.filterData();
            if (window.innerWidth < 768) {
                this.mobileView = true;
            }
            setTimeout(() => {
                this.checkTrigger();
            }, 100);
        },
    };
</script>
